var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=index.es288.js.map
